import { useEffect, useState } from "react";
import { siteSettingsQuery } from "@/lib/sanity";
import { useSanityQuery } from "@/hooks/use-sanity-query";
import type { SiteSettings } from "@/types/content";

export default function Footer() {
  const { data: settings } = useSanityQuery<SiteSettings>(["sanity", "siteSettings"], siteSettingsQuery);
  const [uptime, setUptime] = useState("00:00:00");

  useEffect(() => {
    const startTime = Date.now();

    const formatDuration = (durationMs: number) => {
      const totalSeconds = Math.floor(durationMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const paddedHours = String(hours).padStart(2, "0");
      const paddedMinutes = String(minutes).padStart(2, "0");
      const paddedSeconds = String(seconds).padStart(2, "0");

      if (days > 0) {
        return `${days}d ${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
      }

      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    };

    const updateUptime = () => {
      setUptime(formatDuration(Date.now() - startTime));
    };

    updateUptime();
    const interval = setInterval(updateUptime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="bg-card-bg py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <p className="text-gray-400 font-mono mb-4">
            &copy; {new Date().getFullYear()} {settings?.firstName || "Callie"} {settings?.lastName || "Borgerding"}. {settings?.footerTagline || "Built with security in mind."}
          </p>
          <p className="text-sm text-gray-500 font-mono">
            <span className="text-matrix-green">[STATUS]</span> {settings?.footerStatus || "Systems operational"} • 
            <span className="text-cyber-cyan">[LOCATION]</span> {settings?.location || "United States"} • 
            <span className="text-white">[UPTIME]</span> {settings?.footerUptime || uptime}
          </p>
        </div>
      </div>
    </footer>
  );
}
